import MonitoringModel from '../models/MonitoringModel';
import BaseStore from './BaseStore';

class MonitoringStore extends BaseStore {
  constructor(transportLayer) {
    super(MonitoringModel, transportLayer);
  }
}

export default MonitoringStore;



// WEBPACK FOOTER //
// ./src/stores/MonitoringStore.js